import React from 'react';
import { CarouselProps } from '@marketing-site/components/_contentful/carousel/carousel';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import { Masonry } from '@mui/lab';

export const LifeAtHopper = ({
  headline,
  subheadline,
  itemsCollection,
  sectionId,
}: CarouselProps) => {
  const isMobile = useMediaQuery('(max-width: 600px)');
  return (
    <Stack
      gap={{ mobile: 50, tablet: 400, desktop: 600 }}
      width={'92%'}
      maxWidth={1100}
      m={'0 auto'}
      py={'40px'}
    >
      <Stack gap={100} mb={{ mobile: 200, tablet: 0 }}>
        <Typography
          variant={'h2'}
          fontSize={{ mobile: '24px', desktop: '32px' }}
          fontWeight={800}
          lineHeight={{ mobile: '32px', desktop: '40px' }}
        >
          {headline}
        </Typography>
        <Typography fontSize={'16px'}>{subheadline}</Typography>
      </Stack>
      {isMobile ? (
        <Stack
          direction={'row'}
          gap={300}
          sx={{
            overflowX: 'scroll',
          }}
        >
          {itemsCollection.items.map((item: any, i: number) => (
            <img key={i} src={item.url} alt={item.title} height={'314px'} />
          ))}
        </Stack>
      ) : (
        <Masonry columns={{ tablet: 2, desktop: 3 }} spacing={400} sequential>
          {itemsCollection.items.map((item: any, i: number) => (
            <img key={i} src={item.url} alt={item.title} height={'auto'} />
          ))}
        </Masonry>
      )}
    </Stack>
  );
};
